module.exports = __webpack_public_path__ + "static/img/2.38b9de1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/12/sp/2.png
// module id = 0XX8
// module chunks = 0